import UpsertForm from "@/modules/hrs/internal_debts/view/UpsertForm"
import { useGoBack } from "@/utils/use-go-back"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

export const Upsert = () => {
  const { id } = useParams()

  const [isUpdate, setUpdate] = useState<boolean>(false)

  useEffect(() => {
    if (id) {
      setUpdate(true)
    }
  }, [])
  const { goBack } = useGoBack("/hrs/internal-debts")

  const onCancel = () => goBack()
  const onRefreshProps = () => true
  return (
    <>
      <UpsertForm
        key="UPDATE"
        cancelProps={onCancel}
        openProps={isUpdate}
        refreshProps={onRefreshProps}
        actionType="UPDATE"
        idEdit={id}
      />
    </>
  )
}
